export const pageDisappear = ( page ) => ({
    type: `${page}_DISAPPEAR`,
});
